export default "__VITE_ASSET__B2U3arpW__"